module.exports = __webpack_public_path__ + "img/two_col.8badee95.svg";